export default __webpack_public_path__ + "static/media/Control room_V.4.fcd0f409.png";